import $ from 'jquery';

const MobileMenu = (el) => {
    const $el = $(el);
    const $header = $el.closest('.header');
    const $nav = $el.data('toggle') !== undefined ? $($el.data('toggle')) : $();
    const desktop = window.matchMedia('(min-width: 1120px)');

    const isOpen = () => $el.hasClass('js-state-menu-open');

    const setOpen = (open) => {
        $('body').toggleClass('js-state-menu-open', open);
        $el.toggleClass('js-state-menu-open', open);
        $el.attr('aria-expanded', open);
        $nav.toggleClass('js-state-menu-open', open);

        $('body').children().not($header).not('script').prop('inert', open);
    };

    $el.attr('aria-expanded', false);

    $el.click(function (e) {
        e.preventDefault();
        setOpen(!isOpen());
    });

    const focusables = () => $header
        .find('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
        .filter(':visible');

    $(document).on('keydown', (e) => {
        if (!isOpen()) {
            return;
        }

        if (e.key === 'Escape') {
            setOpen(false);
            $el.trigger('focus');
            return;
        }

        if (e.key !== 'Tab') {
            return;
        }

        const $items = focusables();
        const first = $items.get(0);
        const last = $items.get(-1);

        if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            $el.trigger('focus');
        } else if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            $(last).trigger('focus');
        }
    });

    desktop.addEventListener('change', (e) => {
        if (!e.matches || !isOpen()) {
            return;
        }

        const hadFocus = document.activeElement === el;
        setOpen(false);

        if (hadFocus) {
            $nav.find('a').first().trigger('focus');
        }
    });
};

export default MobileMenu;
